export const initialStatePageKey = 'catalog';
export const CATALOG_AMPLITUDE_PAGE_NAME = 'Catalog';
export const CATALOG_PAGE_KEY = 'catalog';

export const ENROLLMENT_URL_SOURCES = {
  COURSE_SLIDER: 'Course Slider',
  COURSE_LIST: 'Course List',
} as const;
